import { useField } from "formik";
import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";
import { useAdvancedOptions } from "../settings/useAdvancedOptions";

const containsCustomToken = (token: string | null | undefined) => {
  if (!token) {
    return false;
  }

  return token.includes("{TOKEN}");
};

// TODO: Make sure this logic applies also for folder grouping
export const useCustomTokenField = (
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[],
  dataSourceFieldName: string
) => {
  const isAdvancedOptionsEnabled = useAdvancedOptions();

  const [{ value: dataSourceId }] = useField<string>(dataSourceFieldName);

  const selectedDataAssignment = dataAssignments.find(
    (d) => d.id === dataSourceId && dataSourceId != ""
  );

  const isDataSourceWithCustomToken =
    selectedDataAssignment && containsCustomToken(selectedDataAssignment.value);

  return isAdvancedOptionsEnabled && isDataSourceWithCustomToken;
};
